// const addToCartBtn = document.querySelector("[new-data-btn-submit]");

// if (addToCartBtn) {
//   addToCartBtn.addEventListener("click", async (e) => {
//     e.preventDefault();

//     const form = addToCartBtn.closest("form");
//     const formData = new FormData(form);
//     const spinner = form.querySelector('.loading__spinner');
//     if (spinner) spinner.classList.remove('hidden');

//     const variantId = formData.get('id');
//     const requestedQty = parseInt(formData.get('quantity'), 10) || 1;

//        // ----- Get start and end dates -----
//     const startDateInput = document.querySelector("[data-property-date-start]");
//     const endDateInput = document.querySelector("[data-property-date-end]");
//     function parseDateDDMMYYYY(dateStr) {
//       const [day, month, year] = dateStr.split("/").map(Number);
//       return new Date(year, month - 1, day);
//     }

//     const startDateValue = startDateInput?.value;
//     const endDateValue = endDateInput?.value;

//     if (startDateValue && endDateValue) {
//       const start = parseDateDDMMYYYY(startDateValue);
//       const end = parseDateDDMMYYYY(endDateValue);
//       let dayCount = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

//       // Ensure at least 1 day is counted
//       if (dayCount <= 0) dayCount = 1;

//       const daydiv = form.closest('.product-from');

//       const multiDayText = daydiv.getAttribute('data-start-date'); // e.g. "x days selected"
//       const daytext = daydiv.getAttribute('data-daytext');
//       const day_s_text = daydiv.getAttribute('data-daystext')

//       let finalText = '';
//       if (dayCount === 1 && daytext) {
//         finalText = daytext.replace('X', dayCount);;
//       } else if (day_s_text) {
//         finalText = day_s_text.replace('X', dayCount);
//       }

//        if (finalText && multiDayText) {
//         formData.append(`properties[${multiDayText}]`, finalText);
//       }
//     }
  


//     try {
//       // 1️⃣ Get current cart (JSON endpoint)
//       const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
//       const cart = await cartResponse.json();

//       // 2️⃣ Find if this variant is already in cart
//       const existingItem = cart.items.find(item => item.variant_id == variantId);
//       const cartQty = existingItem ? existingItem.quantity : 0;

//       // 3️⃣ Get available stock (passed in DOM as data attribute)
//       const stock = parseInt(form.closest('.product-from').dataset.stock, 10);

//       if (!isNaN(stock)) {
//         const totalRequested = cartQty + requestedQty;

//         const errorMess = document.querySelector('.custom-error-mess');

//           if (totalRequested > stock) {
//             if (errorMess) {
//               let originalText = errorMess.textContent; // e.g. "Sorry, only | items are available. You already have | in your cart."
//               originalText = originalText.replace('|', stock).replace('|', cartQty);
//               errorMess.textContent = originalText;
//               errorMess.style.display = "block";
//             }

//             if (spinner) spinner.classList.add('hidden');
//             return;
//           }

//       }

//       // 4️⃣ Safe to add → call Shopify add.js
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Accept': 'application/json' },
//         body: formData
//       });

//       const data = await response.json();

//       if (data.status) {
//         alert(data.message || 'Sorry, this product cannot be added to the cart.');
//         return;
//       }

//       // 5️⃣ Update cart drawer
//       await updateCartDrawer();
//       // 6️⃣ Update cart count bubble
//       await updateCartCountBubble();

//     } catch (error) {
//       console.error('Add to cart failed:', error);
//       alert('Unable to add product to cart.');
//     } finally {
//       if (spinner) spinner.classList.add('hidden');
//     }
//   });
// }
let isCartUpdating = false;
async function updateSubtotalLabel() {
  // 1. Get cart JSON
  const cart = await fetch('/cart.js').then(r => r.json());

  // 2. Check if ALL items are rental
  const cartOnlyRental = cart.items.length > 0 && cart.items.every(item =>
    item.properties &&
    item.properties.Type === "louer"
  );

  // 3. Select subtotal element
  // Update selector based on your theme:
  const subtotalElement = document.querySelector("[data-ms-subtotal]");

  if (!subtotalElement) return;

  // 4. Add or remove "/ jour"
  if (cartOnlyRental) {
    if (!subtotalElement.textContent.includes("/ jour")) {
      subtotalElement.textContent += " / jour";
    }
  } else {
    subtotalElement.textContent = subtotalElement.textContent.replace(" / jour", "");
  }
}


const modalAddButton = document.querySelector("#add-btn");
if (modalAddButton) {
  modalAddButton.addEventListener("click", async (e) => {
      e.preventDefault();
      // document.getElementById("add-btn").onclick = async function () {
      console.log("add is clicked");

      const { formData } = window.pendingAddToCart;

      // Clear cart before adding
      await fetch('/cart/clear.js', { method: 'POST' });

      // Add item
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      await updateCartDrawer();
      await updateSubtotalLabel();
      await updateCartCountBubble();

      hideAlert();
  });
}


const modalCancelButton = document.querySelector("#cancel-btn");
if (modalCancelButton) {
    modalCancelButton.addEventListener("click", async (e) => {
      hideAlert();
    });
}




const addToCartBtn = document.querySelector("[new-data-btn-submit]");
if (addToCartBtn) {
  addToCartBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    if (addToCartBtn.disabled) return;

    const form = addToCartBtn.closest("form");
    const formData = new FormData(form);
    const spinner = form.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const variantId = formData.get('id');
    const requestedQty = parseInt(formData.get('quantity'), 10) || 1;

    /* ----------------------------------------
        PRODUCT TYPE (from your data attribute)
    ----------------------------------------- */
    const productType = form.dataset.productType === "louer" ? "rental" : "normal";


    /* ----------------------------------------
        DATE LOGIC (your original code)
    ----------------------------------------- */
    const startDateInput = document.querySelector("[data-property-date-start]");
    const endDateInput = document.querySelector("[data-property-date-end]");

    function parseDateDDMMYYYY(dateStr) {
      const [day, month, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    }

    const startDateValue = startDateInput?.value;
    const endDateValue = endDateInput?.value;

    if (startDateValue && endDateValue) {
      const start = parseDateDDMMYYYY(startDateValue);
      const end = parseDateDDMMYYYY(endDateValue);
      // Common Ideas : jour de départ et jour de retour inclus (du 27 au 29 = 3 jours)
      let dayCount = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
      if (dayCount <= 0) dayCount = 1;

      const daydiv = form.closest('.product-from');
      const multiDayText = daydiv.getAttribute('data-start-date');
      const daytext = daydiv.getAttribute('data-daytext');
      const day_s_text = daydiv.getAttribute('data-daystext')

      let finalText = '';
      if (dayCount === 1 && daytext) {
        finalText = daytext.replace('X', dayCount);
      } else if (day_s_text) {
        finalText = day_s_text.replace('X', dayCount);
      }

      if (finalText && multiDayText) {
        formData.append(`properties[${multiDayText}]`, finalText);
      }
    }

    try {
      /* ----------------------------------------
         1 GET CART
      ----------------------------------------- */
      const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await cartResponse.json();

      /* ----------------------------------------
          2 CART TYPE (from product_type field)
      ----------------------------------------- */
      // let cartType = "normal";

      // if (cart.items.some(item =>
      //   item.product_type &&
      //   item.product_type.toLowerCase().includes("rental")
      // )) {
      //   cartType = "rental";
      // }

      let cartType = "normal";

      if (cart.items.some(item => 
        item.properties &&
        item.properties.Type === "louer"
      )) {
        cartType = "rental";
      }
      /* ----------------------------------------
          3 TYPE MISMATCH CHECK
      ----------------------------------------- */
      let mustConfirm = false;
      let alertMessage = "";

      // Common Ideas : location et consommables peuvent cohabiter dans le même panier (plus de vidage du panier)
      if (false && cart.items.length > 0 && productType !== cartType) {
        mustConfirm = true;

        if (productType === "rental") {
          alertMessage = "As this is the rental product, your cart will be cleared.";
        } else {
          alertMessage = "Cart have rental item, if you add this product cart will be cleared.";
        }
      }

      if (mustConfirm) {
        document.getElementById("alert-message").innerText = alertMessage;

        window.pendingAddToCart = {
          formData,
          spinner
        };

        showAlert();
        return;
      }

      /* ----------------------------------------
          4 STOCK CHECK
      ----------------------------------------- */
      const existingItem = cart.items.find(item => item.variant_id == variantId);
      const cartQty = existingItem ? existingItem.quantity : 0;

      const stock = parseInt(form.closest('.product-from').dataset.stock, 10);

      if (!isNaN(stock)) {
        const totalRequested = cartQty + requestedQty;

        const errorMess = document.querySelector('.custom-error-mess');

        if (totalRequested > stock) {
          if (errorMess) {
            if (!errorMess.dataset.template) errorMess.dataset.template = errorMess.textContent;
            let originalText = errorMess.dataset.template;
            originalText = originalText.replace('|', stock).replace('|', cartQty);
            errorMess.textContent = originalText;
            errorMess.style.display = "block";
          }

          if (spinner) spinner.classList.add('hidden');
          return;
        }
      }

      /* ----------------------------------------
          5️5 NORMAL ADD-TO-CART
      ----------------------------------------- */
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      const data = await response.json();

      if (data.status) {
        alert(data.message || 'Sorry, this product cannot be added to the cart.');
        return;
      }

      // Common Ideas : date de location commune à la commande
      if (productType === "rental" && startDateValue && endDateValue && window.ciRentalDates) {
        window.ciRentalDates.afterRentalAdd(startDateValue, endDateValue, cartType !== "rental");
      }

      // Update UI
      await updateCartDrawer();

      await updateSubtotalLabel();


      await updateCartCountBubble();

    } catch (error) {
      console.error('Add to cart failed:', error);
      alert('Unable to add product to cart.');
    } finally {
      if (spinner) spinner.classList.add('hidden');
    }
  });
}




// ----- REMOVE ITEM CLICK EVENT -----
document.addEventListener("click", async (e) => {

  const removeBtn = e.target.closest("cart-drawer .removeitem");
  if (!removeBtn) return;

  e.preventDefault(); 

  const variantId = removeBtn.dataset.variantId;
  const removeUrl = removeBtn.href; 

  try {
    await fetch(removeUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    });

      // 2️⃣ Fetch updated cart section
      await updateCartDrawer();
      await updateSubtotalLabel();
          // 6️⃣ Update cart count bubble
      await updateCartCountBubble();

  } catch (error) {
    console.error("Remove item failed:", error);
  }
});

// document.addEventListener("click", async (e) => {

//   const quoteBtn = e.target.closest(".request-quote-btn");
//   if (!quoteBtn) return;

//   e.preventDefault();

//   const redirectUrl = quoteBtn.getAttribute("href");

//   try {
//     // 1️⃣ Clear entire cart
//     await fetch("/cart/clear.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "Accept": "application/json",
//       },
//     });

//     // 2️⃣ Update cart UI (same as your existing flow)
//     await updateCartDrawer();
//     await updateSubtotalLabel();
//     await updateCartCountBubble();

//   } catch (error) {
//     console.error("Cart clear failed:", error);
//   }

//   // 3️⃣ Redirect (always run)
//   window.location.href = redirectUrl;

// });

// const submitQuote = document.querySelector("#submit-quote.quote-btn");
// document.addEventListener("click", (e) => {

//   const quoteSubmitBtn = e.target.closest("#submit-quote");
//   if (!quoteSubmitBtn) return;

//   setTimeout(async () => {
//     try {
//       await updateCartDrawer();
//       await updateSubtotalLabel();
//       await updateCartCountBubble();
//     } catch (error) {
//       console.error("Cart update failed:", error);
//     }
//   }, 2000);

// });

// Select the cart icon button
const cartBtn = document.querySelector('.custom-cart-icon');
// Add click event
if(cartBtn){

    cartBtn.addEventListener('click', (e) => {
      e.preventDefault(); // Prevent any default behavior
    
      // Select the cart drawer section
      const cartDrawer = document.querySelector('cart-drawer');
    
      if (cartDrawer) {
        cartDrawer.classList.add('active'); // Add the active class
      }
    });
}

// document.addEventListener("click", async (e) => {
//   const btn = e.target.closest("cart-drawer [data-btn-plus], cart-drawer [data-btn-minus]");
//   if (!btn) return;

//   e.preventDefault();

//   const container = btn.closest("div.grid");
//   if (!container) return;

//   const input = container.querySelector("[data-quantity]");
//   let quantity = parseInt(input.value, 10) || 0;

//   const tItem = btn.closest(".t-item-update"); // wrapper for cart item
//   if (!tItem) return;

//   const variantId = tItem.dataset.variantId;
//   const stock = parseInt(tItem.dataset.stock, 10); // make sure you set this in HTML
//   const cartQty = parseInt(tItem.dataset.cartQty, 10) || 0; // current quantity in cart

//   // Calculate requested quantity
//   let newQty = quantity;
//   if (btn.hasAttribute("data-btn-plus")) {
//     newQty += 1;
//   } else if (btn.hasAttribute("data-btn-minus")) {
//     newQty = Math.max(quantity - 1, 0);
//   }

//   // ----- Stock validation -----
//   if (!isNaN(stock) && newQty > stock) {
//     const errorMess = tItem.querySelector(".custom-error-mess-cart");
//     if (errorMess) {
//       errorMess.style.display = "block";

//       // Optional: hide after 5 seconds
//       // setTimeout(() => {
//       //   errorMess.style.display = "none";
//       //   errorMess.textContent = "";
//       // }, 5000);
//     }
//     return; // stop updating cart
//   }

//   // Update input value
//   input.value = newQty;

//   // ----- Shopify AJAX update -----
//   try {
//     const body = JSON.stringify({
//       id: variantId,
//       quantity: newQty
//     });

//     await fetch("/cart/change.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "Accept": "application/json"
//       },
//       body
//     });

//     // Update drawer
//     await updateCartDrawer();
//     await updateSubtotalLabel();
//         // 6️⃣ Update cart count bubble
//       await updateCartCountBubble();

//   } catch (error) {
//     console.error("Updating cart quantity failed:", error);
//   }
// });

document.addEventListener("click", async (e) => {
  const btn = e.target.closest("cart-drawer [data-btn-plus], cart-drawer [data-btn-minus]");
  if (!btn) return;

  e.preventDefault();

  // Prevent double updates
  if (isCartUpdating) return;
  isCartUpdating = true;

  const container = btn.closest("div.grid");
  const tItem = btn.closest(".t-item-update");
  if (!container || !tItem) {
    isCartUpdating = false;
    return;
  }

  const loader = tItem.querySelector(".line-loader");
  if (loader) loader.classList.remove("hidden");

  const input = container.querySelector("[data-quantity]");
  let quantity = parseInt(input.value, 10) || 0;

  const line = parseInt(tItem.dataset.line, 10);
  const stock = parseInt(tItem.dataset.stock, 10);

  let newQty = quantity;
  if (btn.hasAttribute("data-btn-plus")) newQty++;
  else if (btn.hasAttribute("data-btn-minus")) newQty = Math.max(quantity - 1, 0);

  // Stock check
  if (!isNaN(stock) && newQty > stock) {
    const errorMess = tItem.querySelector(".custom-error-mess-cart");
    if (errorMess) errorMess.style.display = "block";
    if (loader) loader.classList.add("hidden");
    isCartUpdating = false;
    return;
  }

  input.value = newQty;

  try {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ line: line, quantity: newQty })
    });

    await updateCartDrawer();
    await updateSubtotalLabel();
    await updateCartCountBubble();

  } catch (error) {
    console.error("Updating cart quantity failed:", error);
  }

  if (loader) loader.classList.add("hidden");
  isCartUpdating = false;
});





// ----- HELPER FUNCTION TO UPDATE CART -----
async function updateCartDrawer() {
  try {
    const response = await fetch("/?sections=cart-drawer");
    const data = await response.json();

    if (data["cart-drawer"]) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data["cart-drawer"];

      const newSection = tempDiv.querySelector("#shopify-section-cart-drawer");
      const oldSection = document.querySelector("#shopify-section-cart-drawer");

      if (newSection && oldSection) {
        oldSection.replaceWith(newSection);
        newSection.querySelector("cart-drawer")?.classList.add("active");
      }
    }
  } catch (error) {
    console.error("Updating cart drawer failed:", error);
  }
}

// ============= cart count update
async function updateCartCountBubble() {
  try {
    // Get the latest cart JSON
    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await response.json();

    const cartCountBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
    if (cartCountBubble) {
      const newCartCount = cart.item_count;

      cartCountBubble.textContent = newCartCount;

      if (newCartCount > 0) {
        cartCountBubble.classList.remove('hidden');
      } else {
        cartCountBubble.classList.add('hidden');
      }
    }
  } catch (error) {
    console.error("Failed to update cart count bubble:", error);
  }
}


  const minusBtn = document.querySelector(".product-from [data-btn-minus]");
  const plusBtn = document.querySelector(".product-from [data-btn-plus]");
  const qtyInput = document.querySelector(".product-from [data-quantity]");


  // 🔽 Minus button
  if (minusBtn) {
    minusBtn.addEventListener("click", () => {
      let current = parseInt(qtyInput.value, 10) || 1;
      if (current > 1) {
        qtyInput.value = current - 1;
      }
    });
  }

  // 🔼 Plus button
  if (plusBtn) {
    plusBtn.addEventListener("click", () => {
      let current = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = current + 1;
    });
  }

  // ✍️ Input validation
  if (qtyInput) {
    qtyInput.addEventListener("input", () => {
      qtyInput.value = qtyInput.value.replace(/[^0-9]/g, "");
      if (qtyInput.value === "" || parseInt(qtyInput.value, 10) < 1) {
        qtyInput.value = 1;
      }
    });
  }

// =============== cart-drawer close click
document.addEventListener('click', (e) => {
  const cartDrawere = document.querySelector('cart-drawer');

  if (!cartDrawere) return;

  // Click on overlay
  if (e.target.closest('.cart-drawer__overlay')) {
    cartDrawere.classList.remove('active');
  }

  // Click on close button
  if (e.target.closest('.drawer__close')) {
    cartDrawere.classList.remove('active');
  }
});




document.addEventListener("DOMContentLoaded", () => {
  initProductVariantPickers();
  updateSubtotalLabel();
});

function guessColorFromName(name) {
  const n = name.toLowerCase();
  const rules = [
    [/aqua|cyan|turquoise|teal|lagoon|ocean|sky/, '#2bb5c0'],
    [/leaf|sage|olive|forest|moss|green|vert|emerald|jade|lime/, '#5a7a4a'],
    [/navy|bleu|blue|indigo|denim|cobalt|azure/, '#2f5f8f'],
    [/coral|salmon|peach|apricot|tangerine/, '#e8836a'],
    [/orange|pumpkin|rust|copper|terracotta/, '#d4743a'],
    [/rose|pink|blush|fuchsia|magenta|raspberry/, '#d4849a'],
    [/red|rouge|crimson|cherry|scarlet|ruby/, '#c0392b'],
    [/yellow|jaune|mustard|honey|lemon|sun|gold/, '#d4a72c'],
    [/purple|violet|lavender|lilac|mauve|plum|grape/, '#8b6fad'],
    [/brown|marron|chocolate|coffee|walnut|cocoa|tan|camel/, '#8b5e3c'],
    [/beige|sand|cream|ivory|ecru|natural|linen|oat|stone|taupe/, '#d8cbb8'],
    [/grey|gray|gris|charcoal|slate|silver|ash|smoke|graphite/, '#8a8a8a'],
    [/white|blanc|snow|pearl|snowdrop/, '#f4f4f4'],
    [/black|noir|ebony|onyx|midnight/, '#1a1a1a'],
    [/wine|burgundy|bordeaux|maroon|plum/, '#722f37'],
    [/mint|seafoam|celadon/, '#98d4bb'],
    [/lilac|wisteria|heather/, '#b39bc8'],
    [/sunset|amber|saffron/, '#e8a54b'],
    [/berry|mulberry/, '#7b3f61'],
    [/nude|flesh|skin/, '#e3c6a8'],
  ];

  for (const [pattern, color] of rules) {
    if (pattern.test(n)) return color;
  }

  return null;
}

function applySwatchColor(label, color) {
  label.style.backgroundColor = color;
  label.style.backgroundImage = 'none';

  if (['#f4f4f4', '#ffffff', '#fff', '#d8cbb8', '#e3c6a8', '#e8dcc8'].includes(color.toLowerCase())) {
    label.style.borderColor = 'rgba(0, 0, 0, 0.15)';
  }
}

function initProductVariantPickers() {
  const COLOR_MAP = {
    noir: '#000000',
    black: '#000000',
    blanc: '#ffffff',
    white: '#ffffff',
    rouge: '#ff0000',
    red: '#ff0000',
    bleu: '#0000ff',
    blue: '#0000ff',
    vert: '#008000',
    green: '#008000',
    gris: '#808080',
    gray: '#808080',
    grey: '#808080',
    jaune: '#ffff00',
    yellow: '#ffff00',
    orange: '#ffa500',
    rose: '#ffc0cb',
    pink: '#ffc0cb',
    violet: '#800080',
    purple: '#800080',
    marron: '#8b4513',
    brown: '#8b4513',
    beige: '#f5f5dc',
    argent: '#c0c0c0',
    silver: '#c0c0c0',
    or: '#ffd700',
    gold: '#ffd700',
  };

  document.querySelectorAll('[data-product-form]').forEach((formWrapper) => {
    const variantsScript = formWrapper.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error('Unable to parse product variants', error);
      return;
    }

    const form = formWrapper.querySelector('form');
    const variantInput = form?.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]') || document.querySelector('.product-price');
    const submitBtn = form?.querySelector('[data-btn-submit]');
    const picker = formWrapper.querySelector('[data-variant-picker]');

    if (!form || !variantInput || !picker) return;

    const optionInputs = [...picker.querySelectorAll('input[type="radio"]')];
    let stockMap = {};
    try {
      const stockScript = formWrapper.querySelector('[data-ci-variant-stock]');
      if (stockScript) stockMap = JSON.parse(stockScript.textContent);
    } catch (error) {
      stockMap = {};
    }
    const moneyFormat = priceEl?.dataset.moneyFormat || '{{amount}} €';

    picker.querySelectorAll('[data-swatch-image]').forEach((label) => {
      label.style.backgroundImage = `url(${label.dataset.swatchImage})`;
      label.style.backgroundSize = 'cover';
      label.style.backgroundPosition = 'center';
    });

    picker.querySelectorAll('[data-color-name]').forEach((label) => {
      const name = label.dataset.colorName?.trim();
      if (!name) return;

      const exactColor = COLOR_MAP[name.toLowerCase()];
      const guessedColor = exactColor || guessColorFromName(name);

      if (guessedColor) {
        applySwatchColor(label, guessedColor);
      }
    });

    picker.querySelectorAll('.product-variant-swatch').forEach((label) => {
      if (label.dataset.colorName) return;
      if (label.style.backgroundImage || label.style.backgroundColor) return;

      const title = label.getAttribute('title');
      const guessedColor = title ? guessColorFromName(title) : null;
      if (guessedColor) applySwatchColor(label, guessedColor);
    });

    function getSelectedOptions() {
      const selected = {};
      optionInputs.forEach((input) => {
        if (input.checked) {
          selected[input.dataset.optionPosition] = input.dataset.optionValue;
        }
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find((variant) =>
        Object.entries(selected).every(([pos, val]) => {
          const optionIndex = parseInt(pos, 10) - 1;
          return [variant.option1, variant.option2, variant.option3][optionIndex] === val;
        })
      );
    }

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return `${(cents / 100).toFixed(2)} €`;
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const fieldsets = picker.querySelectorAll('fieldset');
      const allSelected = Object.keys(selected).length >= fieldsets.length;
      formWrapper.dataset.variantSelected = allSelected ? 'true' : 'false';
      if (!allSelected) {
        ciRefreshSubmit(formWrapper);
        return;
      }
      const variant = findVariant(selected);
      if (!variant) {
        formWrapper.dataset.available = 'false';
        ciRefreshSubmit(formWrapper);
        return;
      }

      variantInput.value = variant.id;

      optionInputs.forEach((input) => {
        if (!input.checked) return;
        const selectedLabel = picker.querySelector(
          `[data-selected-option="${input.dataset.optionPosition}"]`
        );
        if (selectedLabel) selectedLabel.textContent = input.dataset.optionValue;
      });

      if (priceEl) {
        const rentalSuffix = formWrapper.dataset.rentalSuffix || '';
        priceEl.textContent = formatMoney(variant.price) + rentalSuffix;
      }

      const imageUrl = variant.featured_image?.src;
      if (imageUrl) {
        document.querySelectorAll('.demo-trigger, .demo-trigger-2').forEach((img) => {
          img.src = imageUrl;
          img.dataset.zoom = imageUrl;
        });
      }

      const stockInfo = stockMap[String(variant.id)];
      if (stockInfo && stockInfo.managed && stockInfo.policy !== 'continue') {
        formWrapper.dataset.stock = stockInfo.qty;
      } else {
        delete formWrapper.dataset.stock;
      }
      const errorMess = form.querySelector('.custom-error-mess');
      if (errorMess) errorMess.style.display = 'none';

      formWrapper.dataset.available = stockInfo ? String(stockInfo.available) : String(variant.available);
      ciRefreshSubmit(formWrapper);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) {
        updateVariant();
      }
    });

    updateVariant();
  });
}


/* =====================================================================
   Common Ideas : état du bouton "Demander un devis"
   Actif seulement si : variante choisie (si le produit en a), variante
   disponible, et pour la location dates de début et de fin renseignées.
   ===================================================================== */
function ciRefreshSubmit(formWrapper) {
  if (!formWrapper) return;
  const form = formWrapper.querySelector('form');
  const btn = form && form.querySelector('[data-btn-submit]');
  if (!btn) return;

  const isRental = form.dataset.productType === 'louer';
  const hasVariants = formWrapper.dataset.hasVariants === 'true';
  const variantOk = !hasVariants || formWrapper.dataset.variantSelected === 'true';
  const available = formWrapper.dataset.available !== 'false';
  const start = document.querySelector('[data-property-date-start]');
  const end = document.querySelector('[data-property-date-end]');
  const datesOk = !isRental || (start && end && start.value !== '' && end.value !== '');

  const enabled = variantOk && available && datesOk;
  btn.disabled = !enabled;
  btn.classList.toggle('t-disabled', !enabled);

  let hint = formWrapper.querySelector('.ci-form-hint');
  if (!hint) {
    hint = document.createElement('p');
    hint.className = 'ci-form-hint font-switzer text-md text-white';
    hint.style.cssText = 'margin-top:10px;opacity:.85;width:100%;';
    form.appendChild(hint);
  }
  let message = '';
  if (!variantOk) message = 'Veuillez sélectionner une option avant de valider.';
  else if (!available) message = 'Cette option est indisponible pour le moment.';
  else if (!datesOk) message = 'Veuillez sélectionner une date de début et de fin.';
  hint.textContent = message;
  hint.style.display = message ? 'block' : 'none';
}

function ciInitSubmitStates() {
  document.querySelectorAll('[data-product-form]').forEach((formWrapper) => {
    if (formWrapper.dataset.hasVariants !== 'true') {
      formWrapper.dataset.variantSelected = 'true';
    } else if (!formWrapper.dataset.variantSelected) {
      formWrapper.dataset.variantSelected = 'false';
    }
    ciRefreshSubmit(formWrapper);
  });
}

document.addEventListener('ci:dates-change', () => {
  document.querySelectorAll('[data-product-form]').forEach((fw) => ciRefreshSubmit(fw));
  if (window.ciRentalDates) window.ciRentalDates.onManualChange();
});

document.addEventListener('DOMContentLoaded', () => {
  ciInitSubmitStates();
});


/* =====================================================================
   Common Ideas : date de location commune à toute la commande
   - au premier article en location ajouté, on propose d'appliquer ses
     dates aux prochains articles ;
   - si oui, les dates sont pré-remplies sur les fiches produit suivantes
     (toujours modifiables) ;
   - remis à zéro quand le panier ne contient plus de location.
   ===================================================================== */
window.ciRentalDates = (function () {
  const KEY = 'ci_rental_dates';
  let applying = false;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function write(data) {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }
  function parse(str) {
    const parts = (str || '').split('/').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return null;
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }

  function ensureStyles() {
    if (document.getElementById('ci-rental-styles')) return;
    const style = document.createElement('style');
    style.id = 'ci-rental-styles';
    style.textContent = `
      .ci-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;}
      .ci-modal{background:#fff;color:#111;border-radius:8px;max-width:440px;width:100%;padding:28px 24px;font-family:var(--font-switzer, Arial, sans-serif);}
      .ci-modal h3{font-family:var(--heading-font, Arial, sans-serif);font-size:24px;line-height:1.1;text-transform:uppercase;margin:0 0 12px;}
      .ci-modal p{font-size:16px;line-height:1.5;margin:0 0 20px;}
      .ci-modal__actions{display:flex;gap:10px;flex-wrap:wrap;}
      .ci-modal__btn{cursor:pointer;border-radius:4px;padding:10px 18px;font-size:16px;border:1px solid #000;background:#fff;color:#000;}
      .ci-modal__btn--primary{background:#000;color:#fff;}
      .ci-rental-note{font-family:var(--font-switzer, Arial, sans-serif);font-size:14px;color:#fff;opacity:.85;margin:6px 0 0;}
    `;
    document.head.appendChild(style);
  }

  function askToApply(start, end) {
    ensureStyles();
    const overlay = document.createElement('div');
    overlay.className = 'ci-modal-overlay';
    overlay.innerHTML = `
      <div class="ci-modal" role="dialog" aria-modal="true" aria-labelledby="ci-modal-title">
        <h3 id="ci-modal-title">Mêmes dates pour toute la location ?</h3>
        <p>Voulez-vous appliquer automatiquement les dates du <b>${start}</b> au <b>${end}</b> aux prochains articles que vous ajouterez ? Vous pourrez toujours les modifier sur chaque produit.</p>
        <div class="ci-modal__actions">
          <button type="button" class="ci-modal__btn ci-modal__btn--primary" data-ci-yes>Oui, appliquer ces dates</button>
          <button type="button" class="ci-modal__btn" data-ci-no>Non merci</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    overlay.querySelector('[data-ci-yes]').addEventListener('click', () => {
      write({ start, end, apply: true });
      overlay.remove();
    });
    overlay.querySelector('[data-ci-no]').addEventListener('click', () => {
      write({ start, end, apply: false });
      overlay.remove();
    });
  }

  function afterRentalAdd(start, end, firstRental) {
    const saved = read();
    if (firstRental || !saved) {
      askToApply(start, end);
      return;
    }
    if (saved.apply) write({ start, end, apply: true });
  }

  function onManualChange() {
    // rien à faire : les nouvelles dates seront mémorisées à l'ajout au panier
  }

  async function prefill() {
    const saved = read();
    if (!saved || !saved.apply) return;
    const pickers = document.querySelectorAll('t-date');
    if (!pickers.length) return;
    const startDate = parse(saved.start);
    const endDate = parse(saved.end);
    if (!startDate || !endDate) return;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    if (startDate < today) return;

    try { await customElements.whenDefined('t-date'); } catch (e) { return; }
    let tries = 0;
    while ([...pickers].some((p) => !p.calendar) && tries < 40) {
      await new Promise((r) => setTimeout(r, 100));
      tries++;
    }
    applying = true;
    pickers.forEach((p) => {
      if (!p.calendar) return;
      const date = p.dataset.type === 'end' ? endDate : startDate;
      p.calendar.selectDate(date);
      p.calendar.setViewDate && p.calendar.setViewDate(date);
    });
    applying = false;

    ensureStyles();
    const pickerWrap = pickers[pickers.length - 1].closest('.grid');
    const container = pickerWrap ? pickerWrap.parentElement : null;
    if (container && !document.querySelector('.ci-rental-note')) {
      const note = document.createElement('p');
      note.className = 'ci-rental-note';
      note.textContent = 'Les dates de votre location ont été appliquées. Vous pouvez les modifier si besoin.';
      container.insertAdjacentElement('afterend', note);
    }
  }

  async function syncWithCart() {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const hasRental = cart.items.some((item) => item.properties && item.properties.Type === 'louer');
      if (!hasRental) clear();
      return hasRental;
    } catch (e) {
      return true;
    }
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const hasRental = await syncWithCart();
    if (hasRental) prefill();
  });

  return { afterRentalAdd, onManualChange, prefill, clear };
})();
